import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";

import toast from "react-hot-toast";
import ImageUpdate from "components/shared/ImageUpdate";
import { useDispatch, useSelector } from "react-redux";
import { getSingleService, updateService } from "store/actions";
import { EditorComponent } from "components/shared/FormComponents";
import Loader from "components/shared/Loader";

const EditService = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const { singleService, loading } = useSelector((state) => state?.services);

  const [selectedImage, setSelectedImage] = useState({
    preview: "",
    path: "",
  });
  const [description, setDescription] = useState("");
  const [selectedIcon, setSelectedIcon] = useState({
    preview: "",
    path: "",
  });

  useEffect(() => {
    dispatch(getSingleService({ id }));
  }, [dispatch, id]);

  useEffect(() => {
    reset({
      title: singleService?.title,
    });

    setSelectedImage({
      preview: singleService?.image,
      path: singleService?.image,
    });

    setDescription(singleService?.description);

    setSelectedIcon({
      preview: singleService?.icon,
      path: singleService?.icon,
    });
  }, [singleService, reset]);

  const onSubmit = (data) => {
    data.icon = selectedIcon.path;
    data.description = description;
    data.image = selectedImage.path;

    dispatch(
      updateService({
        id,
        data,
        navigate,
        toast,
      })
    );
  };

  if (loading) return <Loader />;

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>تعديل بيانات الخدمة</h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col xl={10} md={12}>
                <Row>
                  <Col lg={3} xs={12}>
                    <div className="form-group upload-contain required">
                      <h5>ايقونة الخدمة</h5>
                      <ImageUpdate
                        selectedImage={selectedIcon}
                        setSelectedImage={setSelectedIcon}
                      />
                    </div>
                  </Col>
                  <Col lg={6} xs={12} className="card-settings">
                    <div className="form-group required upload-cover">
                      <h5>صورة الخدمة</h5>
                      <ImageUpdate
                        selectedImage={selectedImage}
                        setSelectedImage={setSelectedImage}
                      />
                    </div>
                  </Col>
                  <Col lg={12} xs={12}>
                    <div className="form-group required">
                      <h5>اسم الخدمة </h5>
                      <div>
                        <input
                          type="text"
                          className="form-control form-outline"
                          placeholder="اسم الخدمة "
                          {...register("title", { required: true })}
                        />
                      </div>
                      <p className="error-hint">
                        {errors?.title && "يرجي ادخال اسم الخدمة "}
                      </p>
                    </div>
                  </Col>

                  <Col lg={12} xs={12}>
                    <div className="form-group required">
                      <h5>وصف</h5>
                      <div>
                        <EditorComponent
                          name="description"
                          setData={setDescription}
                          initialValue={description}
                        />
                      </div>
                      <p className="error-hint">
                        {description === "" && "يرجي ادخال وصف الخدمة"}
                      </p>
                    </div>
                  </Col>
                  <Col lg={4} xs={12}>
                    <div className="form-group">
                      <button type="submit" className="btn btn-blue">
                        تعديل
                      </button>
                    </div>
                  </Col>
                </Row>
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditService;
